import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  styled,
  Typography,
  TextField,
  Link,
  Divider,
  Select,
  InputLabel,
  MenuItem,
  OutlinedInput,
  SelectChangeEvent,
  FormHelperText,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Swal from "sweetalert2";
import { useHistory, useLocation } from "react-router-dom";
import { Style } from "@mui/icons-material";
import {
  APIEndpointWeb,
  GetLocalStorageAccessToken,
  webapi,
} from "../../../../client/web";
import LoadingIndicator from "./Loading/LoadingIndicator";

interface FormData {
  address: string;
  no: string;
  street: string;
  province: string;
  district: string;
  sub_district: string;
  zip_code: string;
}

interface IProvince {
  province_thai_name: string;
  province_english_name: string;
  province_code: string;
}

interface IDistrict {
  province_code: string;
  district_name: string;
  district_thai_name: string;
  district_code: string;
}

interface ITambon {
  tambon_thai_name: string;
  zip_code: string;
}

interface LocationState {
  formData: string;
}

const FormPersonal: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    address: "",
    no: "",
    street: "",
    province: "",
    district: "",
    sub_district: "",
    zip_code: "",
  });
  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});
  const history = useHistory();
  const [dataForm, setDataForm] = useState<string | null>(null);
  const [hcodeValue, setHcodeValue] = useState<string | null>("");
  const [loading, setLoading] = useState(false);
  const [allProvince, setAllProvince] = useState<IProvince[]>([]);
  const [provinceCode, setProvinceCode] = useState<string | null>("");
  const [allDistricts, setAllDistricts] = useState<any[]>([]);
  const [allTambon, setAllTambon] = useState<any[]>([]);
  const [filteredDistricts, setFilteredDistricts] = useState<IDistrict[]>([]);
  const [selectedDistrict, setSelectedDistrict] = useState<IDistrict | null>(
    null
  );
  const [selectedProvince, setSelectedProvince] = useState<IProvince | null>(
    null
  );
  const [accessToken, setAccessToken] = useState<string>(
    GetLocalStorageAccessToken()
  );
  const [loadingDistricts, setLoadingDistricts] = useState<boolean>(false);
  const [loadingTambon, setLoadingTambon] = useState<boolean>(false);

  const location = useLocation<any>();

  // Log the location object to debug the state
  useEffect(() => {}, [location]);

  const dataFormState = location.state?.state?.formData || {};
  const { address, ...restOfDataFormState } = dataFormState;

  useEffect(() => {
    const fetchData = async () => {
      const storedData = localStorage.getItem("organization");
      const hcodeData = localStorage.getItem("hcode");
      if (hcodeData && storedData) {
        setHcodeValue(JSON.parse(storedData).hcode);
      }
      if (storedData) {
        try {
          const parsedData = JSON.parse(storedData);
          if (parsedData.address) {
            let parsedDataAddress = {
              address: parsedData.address.address || "",
              no: parsedData.address.no || "",
              street: parsedData.address.street || "",
              province: parsedData.address.province || "",
              district: parsedData.address.district || "",
              sub_district: parsedData.address.sub_district || "",
              zip_code: parsedData.address.zip_code || "",
            };
            await setFormData(parsedDataAddress);
            await getDataAllProvince(parsedDataAddress);
          } else {
            getDataAllProvince(null);
          }
        } catch (error) {
          getDataAllProvince(null);
          console.error("Error parsing JSON from localStorage:", error);
        }
      } else {
        getDataAllProvince(null);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (allProvince) {
      setAllDistricts(
        allDistricts.filter((d) => d.province_thai_name === allProvince)
      );
      setSelectedDistrict(null); // รีเซ็ตค่าอำเภอเมื่อเปลี่ยนจังหวัด
    } else {
      setAllDistricts([]);
    }
  }, [allProvince]);

  useEffect(() => {
    if (selectedProvince && Array.isArray(allDistricts)) {
      const filtered = allDistricts.filter(
        (d) => d.province_code === selectedProvince.province_code
      );
      setFilteredDistricts(filtered);
    }
  }, [selectedProvince, allDistricts]);

  useEffect(() => {
    // console.log('allTambon:', allTambon);
    // console.log('formData.zip_code:', formData.zip_code);
  }, [allTambon, formData.zip_code]);

  const validateForm = () => {
    let newErrors: { [key: string]: boolean } = {};
    if (!formData.address) newErrors.address = true;
    if (!formData.no) newErrors.no = true;
    if (!formData.street) newErrors.street = true;
    if (!formData.province) newErrors.province = true;
    if (!formData.district) newErrors.district = true;
    if (!formData.sub_district) newErrors.sub_district = true;
    if (!formData.zip_code) newErrors.zip_code = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ถ้าค่าว่าง return false
  };

  const handleFormChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "zip_code") {
      if (!/^\d*$/.test(value)) return;
    }

    if (name === "no") {
      if (!/^\d*\/?\d*$/.test(value)) return;
    }

    /////////////////////////////////////////////
    if (name === "sub_district") {
      var xml = allTambon.find((p: any) => p.tambon_thai_name === value);
      if (xml) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          sub_district: value,
          zip_code: xml.zip_code,
        }));
      }
    } else {
      setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value === "",
    }));
  };

  const getDataAllProvince = async (dataProvince: FormData | null) => {
    try {
      const { data } = await webapi.get(`${APIEndpointWeb.GetAllProvince}`);

      if (Array.isArray(data.result)) {
        setAllProvince(data.result);
        if (dataProvince) {
          const xml = data.result.find(
            (p: any) => p.province_thai_name === dataProvince.province
          );
          if (xml) {
            await getDataAllDistrict(xml, dataProvince);
          } else {
            let formDatamock = dataProvince;
            formDatamock.province = "";
            formDatamock.district = "";
            formDatamock.sub_district = "";
            formDatamock.zip_code = "";
            setFormData(formDatamock);
          }
        }
      } else {
        console.error("Unexpected API response:", data);
        setAllProvince([]);
      }
    } catch (error) {
      console.log(error);
      setAllProvince([]);
    }
  };

  const getDataAllDistrict = async (
    value: IProvince | null,
    dataProvince: FormData | null = null
  ) => {
    // console.log('value sdss:>> ', value?.province_code);
    try {
      setLoadingDistricts(true);
      setLoadingTambon(true);
      var { data } = await webapi.get(
        `${APIEndpointWeb.GetAllDistrict}${value?.province_code}`
      );
      // setAllDistricts(data.result)
      if (Array.isArray(data.result)) {
        setAllDistricts(data.result);
        if (value && dataProvince) {
          const xml = data.result.find(
            (p: any) => p.district_thai_name === dataProvince.district
          );
          if (xml) {
            let dataCode: IDistrict = {
              province_code: xml.province_code,
              district_name: xml.district_thai_name,
              district_thai_name: xml.district_thai_name,
              district_code: xml.district_code,
            };
            await getDataGetAllTambon(dataCode, dataProvince);
          } else {
            let formDatamock = dataProvince;
            formDatamock.district = "";
            formDatamock.sub_district = "";
            formDatamock.zip_code = "";
            setFormData(formDatamock);
          }
        }
      } else {
        setAllDistricts([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingDistricts(false);
      setLoadingTambon(false);
    }
  };

  const getDataGetAllTambon = async (
    selectedOption: IDistrict | null,
    dataProvince: FormData | null = null
  ) => {
    // console.log('getDataGetAllTambongetDataGetAllTambongetDataGetAllTambongetDataGetAllTambongetDataGetAllTambongetDataGetAllTambongetDataGetAllTambon :>> ', selectedOption);
    try {
      setLoadingTambon(true);
      var { data } = await webapi.get(
        `${APIEndpointWeb.GetAllTambon}${selectedOption?.district_code}&province_code=${selectedOption?.province_code}`
      );

      // console.log('dataProvinceSubbbbbbbbbbbb :>> ', dataProvince?.sub_district);
      if (Array.isArray(data.result)) {
        setAllTambon(data.result);
        ///////////////////////////////////////////////// ทำครั้งแรก
        if (dataProvince) {
          const xml = data.result.find(
            (p: any) => p.tambon_thai_name === dataProvince.sub_district
          );
          if (xml) {
            let formDatamock = dataProvince;
            formDatamock.zip_code = xml.zip_code;
            setFormData(formDatamock);
          } else {
            let formDatamock = dataProvince;
            formDatamock.sub_district = "";
            formDatamock.zip_code = "";
            setFormData(formDatamock);
          }
        }
        //////////////////////////////////////////////
      } else {
        setAllTambon([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingTambon(false);
    }
  };

  const handleProvinceChange = (_: any, value: IProvince | null) => {
    if (!value) {
      setSelectedProvince(null);
      setFilteredDistricts([]);
      setFormData((prev) => ({
        ...prev,
        province: "",
        district: "",
        sub_district: "",
        zip_code: "",
      }));
      return;
    }

    setSelectedProvince(value);
    getDataAllDistrict(value);

    setFormData((prev) => ({
      ...prev,
      province: value.province_thai_name,
      district: "",
      sub_district: "",
      zip_code: "",
    }));
  };

  const handleDistrictChange = (_: any, selectedOption: IDistrict | null) => {
    setFormData((prev) => ({
      ...prev,
      district: selectedOption?.district_thai_name ?? "",
      zip_code: "",
    }));
    getDataGetAllTambon(selectedOption);
  };

  const handleTambonChange = (_: any, selectedOption: ITambon | null) => {
    if (!selectedOption) {
      // ถ้าไม่ได้เลือกตำบล ให้เคลียร์ค่า sub_district และ zip_code
      setFormData((prev) => ({ ...prev, sub_district: "", zip_code: "" }));
      return;
    }

    // ตั้งค่า sub_district และ zip_code ตามค่าที่เลือก
    setFormData((prev) => ({
      ...prev,
      sub_district: selectedOption.tambon_thai_name,
      zip_code: selectedOption.zip_code || prev.zip_code, // ป้องกัน zip_code เป็น undefined
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) {
      Swal.fire({
        title: "กรุณากรอกข้อมูลให้ครบถ้วน",
        icon: "info",
      });
      return;
    }

    try {
      setLoading(true);
      const dataFormApi = {
        access_token: accessToken,
        address: {
          location: formData.address,
          no: formData.no,
          road: formData.street,
          sub_district: formData.sub_district,
          district: formData.district,
          province: formData.province,
          zip_code: formData.zip_code,
        },
        hcode: hcodeValue,
        ...restOfDataFormState,
      };
      // console.log('dataFormApi :>> ', dataFormApi);
      // console.log('restOfDataFormState :>> ', restOfDataFormState);
      var { data } = await webapi.post(
        APIEndpointWeb.PostDocumentPreview,
        dataFormApi
      );

      data.result.address = dataFormApi.address;
      const dataToSend = {
        dataform: data.result,
      };

      Swal.fire({
        title: "ส่งข้อมูลสำเร็จ",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        setTimeout(() => {
          history.push("/document-signature", dataToSend);
        }, 300);
      });

      // Swal.fire({
      //   title: "ส่งข้อมูลสำเร็จ",
      //   icon: "success",
      // });
      // history.push("/document-signature", dataToSend);
      setLoading(false);
    } catch (error: any) {
      console.error(error);
      console.log("error", error);
      // setLoading(false)
      try {
        Swal.fire({
          title: error.response.data.status_result.status_message_th,
          icon: "error",
        });
      } catch (error) {
        Swal.fire({
          title: "ส่งข้อมูลไม่สำเร็จ",
          icon: "error",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ height: "100%" }}>
      <LoadingIndicator open={loading} />
      <Grid item xs={12} md={12} lg={12}>
        <Box
          sx={{
            borderRadius: "15px",
            width: "100%",
            backgroundColor: "#ffffff",
            p: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <Link href="/document-personal" underline="none">
              <NavigateBeforeIcon
                sx={{
                  fontSize: 30,
                  color: "#024F80",
                  ml: 1,
                  cursor: "pointer",
                  mr: 1,
                }}
              />
            </Link>
            <Box>
              <Typography
                variant="h5"
                sx={{
                  color: "#024F80",
                }}
              >
                เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (DSA/NDA)
              </Typography>
            </Box>
          </Box>
          <Grid item xs={12} md={12} lg={12} sx={{}}>
            <Box
              sx={{
                p: 6,
                border: "2px solid #e5eef1",
                backgroundColor: "#f5fdff",
                borderRadius: "10px",
                mt: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <ArrowRightIcon sx={{ color: "#024F80" }} />
                <Typography sx={{ color: "#024F80", fontSize: 20 }}>
                  สถานที่สร้างเอกสารสัญญา
                </Typography>
              </Box>
              <Box sx={{ ml: 3 }}>
                <Typography sx={{ color: "#9C9C9C" }}>
                  กรุณาเลือกกรอกข้อมูลสถานที่สร้างเอกสารสัญญา
                  เพื่อลงนามใบรับรองอิเล็กทรอนิกส์
                </Typography>
              </Box>

              <form onSubmit={handleSubmit}>
                <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
                  <Grid item xs={12} md={12}>
                    <FormControl sx={{ minWidth: "100%" }}>
                      <TextField
                        variant="outlined"
                        sx={{ backgroundColor: "#ffffff" }}
                        label={
                          <span>
                            ที่อยู่สถานที่สร้างเอกสาร{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        id="outlined-basic"
                        placeholder="กรุณากรอกที่อยู่"
                        value={formData.address}
                        name="address"
                        // onChange={handleFormChange}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const regex = /^[^\s]*$/; // regex ตรวจสอบว่าไม่มีช่องว่าง (space)

                          // ถ้าข้อความไม่รวมช่องว่าง (space) จะอัพเดตค่าใน form
                          if (regex.test(inputValue)) {
                            handleFormChange(
                              e as React.ChangeEvent<HTMLInputElement>
                            );
                          }
                        }}
                        error={errors.location}
                        helperText={errors.location ? "กรุณากรอกที่อยู่" : ""}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormControl sx={{ minWidth: "100%" }}>
                      <TextField
                        variant="outlined"
                        sx={{ minWidth: "100%", backgroundColor: "#ffffff" }}
                        label={
                          <span>
                            เลขที่ <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        id="outlined-basic"
                        placeholder="กรุณากรอกเลขที่"
                        value={formData.no}
                        name="no"
                        // onChange={handleFormChange}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const regex = /^[^\s]*$/; // regex ตรวจสอบว่าไม่มีช่องว่าง (space)

                          // ถ้าข้อความไม่รวมช่องว่าง (space) จะอัพเดตค่าใน form
                          if (regex.test(inputValue)) {
                            handleFormChange(
                              e as React.ChangeEvent<HTMLInputElement>
                            );
                          }
                        }}
                        error={errors.no}
                        helperText={errors.no ? "กรุณากรอกเลขที่" : ""}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={9}>
                    <FormControl sx={{ minWidth: "100%" }}>
                      <TextField
                        variant="outlined"
                        sx={{ minWidth: "100%", backgroundColor: "#ffffff" }}
                        label={
                          <span>
                            ถนน <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        id="outlined-size-small"
                        placeholder="กรุณากรอกถนน"
                        value={formData.street}
                        name="street"
                        // onChange={handleFormChange}
                        onChange={(e) => {
                          const inputValue = e.target.value;

                          // ตรวจสอบว่าไม่ให้มีช่องว่างหลังคำแรก
                          const regex = /^[^\s]+(\s[^\s]*)?$/;

                          // อนุญาตให้ลบข้อความได้
                          if (inputValue === "" || regex.test(inputValue)) {
                            handleFormChange(e); // ถ้าข้อความตรงกับเงื่อนไข ก็อัพเดตค่า
                          }
                        }}
                        error={errors.street}
                        helperText={errors.street ? "กรุณากรอกถนน" : ""}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl
                      sx={{ minWidth: "100%" }}
                      size="small"
                      error={Boolean(errors.province)}
                    >
                      <Autocomplete
                        id="province-select"
                        options={allProvince}
                        getOptionLabel={(option) =>
                          option.province_thai_name || ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option.province_code === value.province_code
                        }
                        value={
                          allProvince.find(
                            (option) =>
                              option.province_thai_name === formData.province
                          ) || null
                        }
                        onChange={(event, value: any) =>
                          handleProvinceChange(event, value)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              <span>
                                จังหวัด <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            name="province"
                            variant="outlined"
                            fullWidth
                            error={Boolean(errors.province)}
                            helperText={
                              errors.province ? "กรุณาเลือกจังหวัด" : null
                            }
                            sx={{
                              backgroundColor: "#ffffff",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "4px",
                                backgroundColor: "#ffffff",
                              },
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl
                      sx={{ minWidth: "100%" }}
                      size="small"
                      error={Boolean(errors.district)}
                    >
                      <Autocomplete
                        id="district-select"
                        disabled={!formData.province || loadingDistricts}
                        options={allDistricts}
                        getOptionLabel={(option) => option.district_thai_name}
                        value={
                          allDistricts.find(
                            (option) =>
                              option.district_thai_name === formData.district
                          ) || null
                        }
                        onChange={handleDistrictChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              <span>
                                อำเภอ <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            name="district"
                            variant="outlined"
                            fullWidth
                            error={Boolean(errors.district)}
                            helperText={
                              errors.district ? "กรุณาเลือกอำเภอ / เขต" : null
                            }
                            sx={{
                              backgroundColor: "#ffffff",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "4px",
                                backgroundColor: "#ffffff",
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loadingDistricts ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl
                      sx={{ minWidth: "100%" }}
                      size="small"
                      error={Boolean(errors.sub_district)}
                    >
                      <Autocomplete
                        id="subdistrict-select"
                        disabled={!formData.district || loadingTambon}
                        options={allTambon ?? []} // ป้องกัน options เป็น null หรือ undefined
                        value={
                          allTambon && Array.isArray(allTambon)
                            ? allTambon.find(
                                (option) =>
                                  option.tambon_thai_name ===
                                  formData.sub_district
                              ) || null
                            : null
                        }
                        getOptionLabel={(option) => option.tambon_thai_name}
                        onChange={(event, value: ITambon | null) =>
                          handleTambonChange(event, value)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              <span>
                                ตำบล / แขวง{" "}
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            name="sub_district"
                            variant="outlined"
                            fullWidth
                            error={Boolean(errors.sub_district)}
                            helperText={
                              errors.sub_district
                                ? "กรุณากรอกเลือกตำบล / แขวง"
                                : null
                            }
                            sx={{
                              backgroundColor: "#ffffff",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "4px",
                                backgroundColor: "#ffffff",
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loadingTambon ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      disabled={loadingTambon || !formData?.sub_district}
                      name="zip_code"
                      label={
                        <span>
                          รหัสไปรษณีย์ <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="outlined"
                      sx={{ backgroundColor: "#ffffff" }}
                      value={formData.zip_code || ""}
                      // onChange={handleFormChange}
                      fullWidth
                      onInput={(e) => {
                        const input = e.target as HTMLInputElement;
                        input.value = input.value
                          .replace(/[^0-9]/g, "")
                          .slice(0, 5);
                      }}
                      inputProps={{
                        maxLength: 5,
                        pattern: "[0-9]*",
                        inputMode: "numeric",
                      }}
                      error={Boolean(errors.zip_code)}
                      helperText={errors.zip_code || ""}
                    />
                  </Grid>
                  <Grid container sx={{ mt: 3 }}>
                    <Grid item xs={12}>
                      <Divider sx={{ my: 2 }} />
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <Button
                      type="submit"
                      endIcon={<ArrowForwardIosIcon />}
                      variant="contained"
                      color="primary"
                      sx={{ mt: 2, borderRadius: 5 }}
                    >
                      ดำเนินการต่อ
                    </Button>
                  </Box>
                </Grid>
              </form>
            </Box>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};

export default FormPersonal;
